export default "__VITE_ASSET__DX47zo_9__";